import { render, staticRenderFns } from "./HistoryCardError.vue?vue&type=template&id=2d228cec&"
import script from "./HistoryCardError.vue?vue&type=script&lang=js&"
export * from "./HistoryCardError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports